import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { LogOut, RefreshCw } from "lucide-react";
import { AdminLogin } from "../components/admin/AdminLogin";
import { QuotesTable } from "../components/admin/QuotesTable";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "stopcheni_admin_token";

export default function Admin() {
  const [token, setToken] = useState(() => (() => { try { return sessionStorage.getItem(KEY); } catch { return null; } })());
  const [quotes, setQuotes] = useState(null);

  const logout = useCallback(() => {
    try { sessionStorage.removeItem(KEY); } catch { /* ignore */ }
    setToken(null);
    setQuotes(null);
  }, []);

  const load = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/quotes`, { headers: { Authorization: `Bearer ${token}` } });
      setQuotes(data);
    } catch {
      logout();
    }
  }, [token, logout]);

  useEffect(() => {
    if (token) load();
  }, [token, load]);

  const onLogin = (t) => {
    try { sessionStorage.setItem(KEY, t); } catch { /* memory only */ }
    setToken(t);
  };

  if (!token) return <AdminLogin onLogin={onLogin} api={API} />;

  return (
    <div data-testid="admin-dashboard" className="min-h-screen bg-cs-grey">
      <header className="border-b border-cs-navy/10 bg-cs-navy">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 sm:px-8">
          <span className="font-display text-[15px] font-extrabold text-white">
            Stop Cheni <span className="font-semibold text-cs-yellow">Admin</span>
          </span>
          <button type="button" data-testid="admin-logout-button" onClick={logout} className="inline-flex items-center gap-2 text-sm font-semibold text-white/80 hover:text-white">
            <LogOut className="h-4 w-4" /> Déconnexion
          </button>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-5 py-10 sm:px-8">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
          <div>
            <h1 className="font-display text-3xl font-extrabold tracking-tight text-cs-navy">Demandes de devis</h1>
            <p data-testid="admin-quotes-count" className="mt-1 text-sm text-cs-ink/60">
              {quotes ? `${quotes.length} demande${quotes.length > 1 ? "s" : ""} · les plus récentes en premier` : "Chargement…"}
            </p>
          </div>
          <button type="button" data-testid="admin-refresh-button" onClick={load} className="btn-primary px-4 py-2.5 text-sm">
            <RefreshCw className="h-4 w-4" /> Actualiser
          </button>
        </div>
        {quotes && <QuotesTable quotes={quotes} />}
      </main>
    </div>
  );
}
